import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, of, shareReplay } from 'rxjs';
import { API_URL } from '../utils/injection-tokens/api-url.token';
import {
  User,
  UserDto,
  UserRole,
  CreateUser,
  UpdateUserDto,
} from '../interfaces';
import { Roles } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class UserHttpService {
  private http = inject(HttpClient);

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };

  private apiUrl = inject(API_URL) + 'users';
  private api = inject(API_URL);
  
  getUsersV1(role?: Roles): Observable<User[]> {
    if (role) {
      return this.http.get<User[]>(`${this.apiUrl}?role=${role.toString()}`, this.httpOptions);
    }
    return this.http.get<User[]>(`${this.apiUrl}`, this.httpOptions);

  }


  getUserById(userId: string): Observable<User | null> {
    return this.http.get<User>(`${this.apiUrl}/${userId}`, this.httpOptions)
      .pipe(
        catchError((error) => {
          console.error('Error getting user by ID: ', error);
          return of(null);
        })
      );
  }

  getUserByEmail(email: string): Observable<UserDto> {
    const payload = { email: email };
    return this.http.post<UserDto>(
      `${this.apiUrl}/email`,
      payload,
      this.httpOptions
    );
  }

  getUserRoles(): Observable<UserRole[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get<UserRole[]>(`${this.api}UserRoles/`, httpOptions);
  }

  createUser(newUser: UserDto): Observable<UserDto> {
    return this.http
      .post<UserDto>(this.apiUrl, newUser, this.httpOptions)
      .pipe(shareReplay(1));
  }

  createUserV2(user: CreateUser): Observable<CreateUser> {
    return this.http.post<CreateUser>(`${this.api}users/register`, user);
  }

  updateUser(userId: string, userToUpdate: UpdateUserDto): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/${userId}`,
      userToUpdate,
      this.httpOptions
    );
  }
  activateUser(token: string) {
    return this.http.put<void>(
      `${this.apiUrl}/activate-user?token=${token}`,
      null,
      this.httpOptions
    );
  }

  updatePassword(
    userId: string,
    oldPassword: string,
    newPassword: string
  ): Observable<void> {
    const payload = { password: oldPassword, newPassword };
    return this.http.put<void>(`${this.apiUrl}/${userId}/change-password`, payload);
  }
  comparePasswords(userId: string, password: string): Observable<boolean> {
    const payload = { password };
    return this.http.post<boolean>(
      `${this.apiUrl}/${userId}/compare-passwords`,
      payload
    );
  }

  deleteUser(userId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${userId}`);
  }

  // Coreact Methods
  getCorrectPassword(userId: number): Observable<{ password: string }> {
    return this.http.get<{ password: string }>(
      `${this.apiUrl}/${userId}`,
      this.httpOptions
    );
  }

syncInvestigators(): Observable<{ message: string }> {
  return this.http.post<{ message: string }>(
    `${this.apiUrl}/sync-investigators`,
    null
  );
}
}
